import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import DOMPurify from "dompurify";
import "animate.css";
import {
  FaHouse,
  FaLocationDot,
  FaIndianRupeeSign,
  FaHelmetSafety,
  FaRegClock,
} from "react-icons/fa6";
import { BiFootball } from "react-icons/bi";
import {
  FaBuilding,
  FaRunning,
  FaUmbrellaBeach,
  FaKey,
  FaCheckCircle,
  FaBalanceScale,
} from "react-icons/fa";
import { CgGym, CgGames } from "react-icons/cg";
import {
  GiTennisCourt,
  GiBasketballBasket,
  GiKidSlide,
  GiCctvCamera,
  GiCricketBat,
  GiTheater,
  GiTempleGate,
} from "react-icons/gi";
import { MdOutlinePool, MdOutlineSpa } from "react-icons/md";
import bhkfloorplan from "../assets/img/1-bhk-floorplan.webp";
import costingSheet from "../assets/img/costingsheet.jpg";
import Popup from "../components/Popup";
import Canonical from "../components/Canonical.js";
import apiClient from "../api.js";
import Whatsapp from "../components/Whatsapp.jsx";
import DeveloperSlider from "../components/DeveloperSlider.jsx";
import SubregionSlider from "./../components/SubregionSlider";
import PriceGraph from "../components/PriceGraph.jsx";
import PropertyMap from "../components/PropertyMap.jsx";

const PropertyDetail = () => {
  const params = useParams();
  const [property, setProperty] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [subject, setSubject] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        setLoading(true);
        const res = await apiClient.get(
          `listing/propertyname/${params.slugname}`,
        );
        if (res.status === 200) {
          setProperty(res.data);
          setSubject(res.data.name);
          // fetch meta immediately using the returned _id
          try {
            const metaTag = await apiClient.post("seodata/propertymetainfo", {
              propertyID: res.data._id,
            });
            let fetchedMetaTitle = "";
            let fetchedMetaDescription = "";
            if (metaTag.status === 200 && metaTag.data) {
              fetchedMetaTitle = metaTag.data.metatitle || "";
              fetchedMetaDescription = metaTag.data.metadescription || "";
            } else {
              fetchedMetaTitle = `${res.data.name} in ${res.data.subregion} | ${res.data.BHK} BHK from ₹${res.data.priceRange[0]}`;
              fetchedMetaDescription = `Find ${res.data.BHK} BHK flat at ${res.data.name}, ${res.data.subregion} by ${res.data.devlopername}. Access brochure, floor plans, price list, RERA info & photos on Homes Dekho.`;
            }

            setMetaTitle(fetchedMetaTitle);
            setMetaDescription(fetchedMetaDescription);
          } catch (err) {
            console.log(err.message);
          }

          setLoading(false);
        }
      } catch (error) {
        setError(true);
        setLoading(false);
      }
    };

    fetchProperties();
  }, [params.slugname]);

  // handle popup button
  const [popupData, setPopupData] = useState("");

  const handleButtonClick = (dataName) => {
    // Set the value you want to send to the Popup
    console.log(dataName);
    setPopupData(dataName);
  };

  // save lead form data

  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const res = await apiClient.post("emailsend/send-email", {
        email,
        subject,
        mobile,
        name,
      });

      if (res) {
        // Hide the main form popup
        const mainPopup = document.getElementById("staticBackdrop");
        if (mainPopup) {
          const bootstrapModal = window.bootstrap.Modal.getInstance(mainPopup);
          if (bootstrapModal) bootstrapModal.hide();
        }
        navigate("/thank-you"); // Redirect after successful response
        // window.location.reload(); // Forces a full page reload
        setShowSuccessPopup(true); // Show success popup
        setEmail("");
        setName("");
        setMobile("");
        setSubject("");
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleSuccessPopupClose = () => {
    setShowSuccessPopup(false);
    navigate("/thank-you"); // Redirect or perform other actions if necessary
    window.location.reload(); // Forces a full page reload
  };

  const amenityIcons = {
    "Lawn tennis courts": GiTennisCourt,
    "Kids Play Area": GiKidSlide,
    Clubhouse: FaBuilding,
    "Swimming Pool": MdOutlinePool,
    "Basket Ball Court": GiBasketballBasket,
    Turf: BiFootball,
    Gym: CgGym,
    "Multipurpose halls": FaUmbrellaBeach,
    "Jogging Track": FaRunning,
    "Yoga / Meditation Area": FaUmbrellaBeach,
    "Electric Vehicle Charging": FaUmbrellaBeach,
    "Coworking spaces": FaUmbrellaBeach,
    Spa: MdOutlineSpa,
    "CCTV Camera": GiCctvCamera,
    "Cricket Turf": GiCricketBat,
    Amphitheatre: GiTheater,
    Temple: GiTempleGate,
    "Jain Temple": GiTempleGate,
    Masjid: GiTempleGate,
    "Indoor Games": CgGames,
  };

  // const bhkString =
  //   property.BHK && Array.isArray(property.BHK)
  //     ? property.BHK.length === 1
  //       ? property.BHK[0]
  //       : property.BHK.slice(0, -1).join(", ") + " & " + property.BHK.slice(-1)
  //     : "";

  const getDisplaySubregion = (subregion) => {
    if (subregion === "Dombivali") return "Dombivli";
    else if (subregion === "Vikroli") return "Vikhroli";
    else return subregion;
  };

  const canonicalUrl = window.location.href;

  const hrfLangTag = window.location.href;
  const ogimageUrl =
    property.imageUrls && property.imageUrls.length > 0
      ? property.imageUrls[0]
      : "";

  const schemeaOne = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Product",
    image: property.imageUrls,
    description: property.description,
    name: property.name,
    url: canonicalUrl,
    brand: {
      "@type": "Organization",
      name: property.name,
    },

    review: {
      "@type": "Review",
      reviewRating: {
        "@type": "Rating",
        ratingValue: 5,
        bestRating: "5",
      },
      author: {
        "@type": "Person",
        name: "Homesdekho",
      },
    },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: 4.4,
      reviewCount: "9",
    },
    positiveNotes: {
      "@type": "ItemList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: `${property.name} offers well-planned ${
            property.BHK
          } BHK flats in ${getDisplaySubregion(
            property.subregion,
          )} with great amenities at an affordable price.`,
        },
      ],
    },
    offers: {
      "@type": "AggregateOffer",
      lowPrice: `${property.priceRange}`,
      highPrice: `${property.priceRange}`,
      priceCurrency: "INR",
      offerCount: "2",
    },
  });

  const schemeaTwo = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "ApartmentComplex",
    name: property.name,
    url: canonicalUrl,
    description: property.description,
    image: property.imageUrls,
    address: {
      "@type": "PostalAddress",
      addressLocality: property.address,
      addressRegion: property.location,
      addressCountry: "IN",
    },
  });

  const schemaFour = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Place",
    name: `${property.name}`,
    description: `${property.description}`,
    image: `${property.imageUrls}`,
    url: `${canonicalUrl}`,
    address: {
      "@type": "PostalAddress",
      streetAddress: `${property.address}`,
      addressLocality: `${property.subregion}`,
      addressRegion: `${property.location}`,
      addressCountry: "IN",
    },

    containedInPlace: {
      "@type": "AdministrativeArea",
      name: `${property.subregion}`,
    },

    offers: {
      "@type": "Offer",
      price: `${property.priceRange}`,
      priceCurrency: "INR",
      url: `${canonicalUrl}`,
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Property Type",
        value: "Residential",
      },

      {
        "@type": "PropertyValue",
        name: "Developer",
        value: `${property.devlopername}`,
      },
      {
        "@type": "PropertyValue",
        name: "RERA ID",
        value: `${property.reraName}`,
      },
    ],
  });

  const schemaFive = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: property.name,
    description: property.description,
    image:
      property.imageUrls && property.imageUrls.length > 0
        ? property.imageUrls[0]
        : "",
  });

  return (
    <>
      <Canonical
        canonicalUrl={canonicalUrl}
        title={metaTitle}
        description={metaDescription}
        hrfLang={hrfLangTag}
        schemeaOne={schemeaOne}
        schemeaTwo={schemeaTwo}
        schemaFour={schemaFour}
        schemaFive={schemaFive}
        ogimage={ogimageUrl}
      />
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12">
            {loading && (
              <div className="spinner-border text-danger" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            )}
            {error && (
              <h3 className="text-center">
                Something went wrong... <br />
                Please try again.
              </h3>
            )}
          </div>
        </div>
      </div>
      {/* property Detail  */}

      <main className="main-sections">
        <section className="main-side">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="region-name-div">
                  <ul className="region-name-ul">
                    <li className="region-name-li">
                      <Link>
                        Homes in {property.region} <IoIosArrowDown />
                      </Link>
                    </li>
                    <li className="region-name-li">
                      {property.location === "pune" ? (
                        <Link
                          to={`/pune/propertiesbyregion/${property.subregion}`}
                        >
                          Homes in{" "}
                          {property.subregion === "Dombivali"
                            ? "Dombivli"
                            : property.subregion}
                          <IoIosArrowDown />
                        </Link>
                      ) : (
                        <Link to={`/propertiesbyregion/${property.subregion}`}>
                          Homes in{" "}
                          {property.subregion === "Dombivali"
                            ? "Dombivli"
                            : property.subregion}
                          <IoIosArrowDown />
                        </Link>
                      )}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-12">
                <div className="region-name-div">
                  <ul className="property-region-name-ul">
                    <li className="property-region-name-lis text-capitalize">
                      <Link>
                        {property.location ? property.location : "mumbai"}
                      </Link>
                    </li>
                    <li className="property-region-name-lis">
                      {property.location === "pune" ? (
                        <Link
                          to={`/pune/propertiesbyregion/${property.subregion}`}
                        >
                          Homes in{" "}
                          {property.subregion === "Dombivali"
                            ? "Dombivli"
                            : property.subregion}
                          <IoIosArrowDown />
                        </Link>
                      ) : (
                        <Link to={`/propertiesbyregion/${property.subregion}`}>
                          Homes in{" "}
                          {property.subregion === "Dombivali"
                            ? "Dombivli"
                            : property.subregion}
                          <IoIosArrowDown />
                        </Link>
                      )}
                    </li>
                    <li className="property-region-name-lis">
                      <Link
                        to={`/projects/${
                          property.devlopername
                            ? property.devlopername.replace(/\s+/g, "-")
                            : ""
                        }`}
                      >
                        {" "}
                        {property.devlopername}
                      </Link>
                    </li>
                    <li className="property-region-name-lis">
                      <Link> {property.name}</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-12">
                <div className="lp-design-div">
                  <h1 className="property-name">{property.name}</h1>
                  <div className="mt-3 main-property-img-div">
                    <Link
                      to="/compare"
                      className="compare-btn"
                      state={{ propertyId: property._id }}
                    >
                      <FaBalanceScale />
                    </Link>
                    <img
                      className="img-fluid main-property-img"
                      src={property.imageUrls}
                      alt={`${property.name} residential project in ${property.subregion} - luxury apartments and homes by ${property.devlopername}`}
                    />
                  </div>
                </div>

                {/* mobile property details  */}

                <div className="property-details-div mt-3 mobile-property-details-view">
                  <ul className="luxury-homes-ul">
                    <li
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                      className="animate__animated animate__pulse animate__infinite"
                      onClick={() => handleButtonClick(property.name)}
                    >
                      Luxury Homes
                    </li>
                  </ul>
                  <div className="side-bar-main-address-div">
                    <div className="side-bar-icon-div">
                      <FaHouse />
                    </div>
                    <div className="side-bar-property-detail-div">
                      <p className="sidebar-property-name-txt">Property Name</p>
                      <p className="sidebar-property-real-name-txt">
                        {property.name}
                      </p>
                    </div>
                  </div>
                  <div className="side-bar-main-address-div mt-2">
                    <div className="side-bar-icon-div">
                      <FaLocationDot />
                    </div>
                    <div className="side-bar-property-detail-div">
                      <p className="sidebar-property-name-txt">Location</p>
                      <p className="sidebar-property-real-name-txt">
                        {property.address}
                      </p>
                    </div>
                  </div>
                  <div className="possesion-date-main-div">
                    <div className="side-bar-main-address-div mt-2">
                      <div className="side-bar-icon-div">
                        <FaKey />
                      </div>
                      <div className="side-bar-property-detail-div">
                        <p className="sidebar-property-name-txt">
                          Possession date
                        </p>
                        <p className="sidebar-property-real-name-txt">
                          {property.possessiondate}
                        </p>
                      </div>
                    </div>
                    <div className="side-bar-main-address-div mt-2">
                      <div className="side-bar-icon-div">
                        <FaIndianRupeeSign />
                      </div>
                      <div className="side-bar-property-detail-div">
                        <p className="sidebar-property-name-txt">Price Range</p>
                        <p className="sidebar-property-real-name-txt">
                          {property.price}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="side-bar-main-address-div mt-2">
                    <div className="side-bar-icon-div">
                      <FaHelmetSafety />
                    </div>
                    <div className="side-bar-property-detail-div">
                      <p className="sidebar-property-name-txt">Developer</p>
                      <p className="sidebar-property-real-name-txt">
                        {property.devlopername}
                      </p>
                    </div>
                  </div>
                  <div className="download-brochure-btn-div">
                    <button
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                      className=" download-brochure-btn glow-on-hover"
                      type="button"
                      onClick={() => handleButtonClick(property.name)}
                    >
                      Download Brochure
                    </button>
                  </div>
                </div>
                {/* mobile property details  */}
              </div>
              <div className="col-md-12 mt-3">
                <div className="lp-design-div">
                  <div className="">
                    <h4 className="configuration-txt">
                      Configurations for {property.name}
                    </h4>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      {property &&
                      property.BHK &&
                      Array.isArray(property.BHK) &&
                      property.sqftMin &&
                      Array.isArray(property.sqftMin) &&
                      property.sqftMax &&
                      Array.isArray(property.sqftMax) ? (
                        property.BHK.map((_, index) => (
                          <div key={index} className="config-main-price-div">
                            <div className="config-sqft-div">
                              <div>
                                <FaBuilding className="building-icon" />
                              </div>
                              <div>
                                <p className="bhk-txt">
                                  {property.BHK[index]}
                                  {property.BHK[index] === "Studio"
                                    ? ""
                                    : " BHK"}
                                </p>
                                <p className="sqft-txt">
                                  {property.sqftMin[index]} -{" "}
                                  {property.sqftMax[index]} Sq.ft.
                                </p>
                              </div>
                            </div>
                            {index === 0 ? ( // Show price for the first item
                              <div className="config-price-div">
                                <p
                                  data-bs-toggle="modal"
                                  data-bs-target="#staticBackdrop"
                                  onClick={() =>
                                    handleButtonClick(property.name)
                                  }
                                >
                                  ₹ {property.priceRange[index]}
                                </p>
                              </div>
                            ) : (
                              <div className="config-price-div">
                                <button
                                  data-bs-toggle="modal"
                                  data-bs-target="#staticBackdrop"
                                  type="button"
                                  onClick={() =>
                                    handleButtonClick(property.name)
                                  }
                                  className="floor-plan-btn animate__animated animate__pulse animate__infinite"
                                >
                                  View Price
                                </button>
                              </div>
                            )}
                          </div>
                        ))
                      ) : (
                        <p>Loading data...</p>
                      )}
                    </div>
                    <div className="col-md-4">
                      <div
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop"
                        onClick={() => handleButtonClick(property.name)}
                        className="at-property-img"
                      >
                        <img
                          src={costingSheet}
                          className="costing-sheet-img "
                          alt="Costing Sheet"
                        />
                        <div className="at-property-overlayer"></div>
                        <span
                          onClick={() => handleButtonClick(property.name)}
                          className="btn btn-default at-property-btn"
                        >
                          Enquire Now
                        </span>
                      </div>
                      <div className="at-property-dis">
                        <h5
                          data-bs-toggle="modal"
                          data-bs-target="#staticBackdrop"
                          onClick={() => handleButtonClick(property.name)}
                          className="costing-txt "
                        >
                          Complete Costing Details
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mt-3">
                <div className="lp-design-div">
                  <div className="">
                    <h4 className="configuration-txt">
                      Floor Plan For {property.name}
                    </h4>
                  </div>
                  <div>
                    <ul className="floor-plan-ul">
                      {property &&
                      property.BHK &&
                      Array.isArray(property.BHK) &&
                      property.sqftMin &&
                      Array.isArray(property.sqftMin) &&
                      property.sqftMax &&
                      Array.isArray(property.sqftMax) ? (
                        property.BHK.map((_, index) => (
                          <li
                            data-bs-toggle="modal"
                            data-bs-target="#staticBackdrop"
                            onClick={() => handleButtonClick(property.name)}
                            key={index}
                            className="floor-plan-bhk-txt"
                          >
                            {property.BHK[index]}
                            {property.BHK[index] === "Studio"
                              ? ""
                              : " BHK"}{" "}
                            <br />
                            <span>
                              {property.sqftMin[index]} -{" "}
                              {property.sqftMax[index]} Sq.ft.
                            </span>
                          </li>
                        ))
                      ) : (
                        <p>Loading data...</p>
                      )}
                    </ul>
                  </div>
                  <div>
                    <img
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                      onClick={() => handleButtonClick(property.name)}
                      className="img-fluid floor-plan-img main-property-img"
                      src={bhkfloorplan}
                      alt={`Floor plan of ${property.name} - residential project in ${property.subregion} featuring modern apartment layouts`}
                    />
                    <div className="w-100 text-center">
                      <button
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop"
                        type="button"
                        onClick={() => handleButtonClick(property.name)}
                        className="floor-plan-btn animate__animated animate__pulse animate__infinite"
                      >
                        View Sample Flat
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mt-3">
                <div className="lp-design-div">
                  <div className="">
                    <h4 className="configuration-txt">About {property.name}</h4>
                  </div>
                  <div>
                    <p className="project-overview-txt">
                      {property.description}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mt-3">
                <div className="lp-design-div">
                  <div className="">
                    <h4 className="configuration-txt">Property Map</h4>
                  </div>
                  <div>
                    <PropertyMap area={property.subregion} />
                  </div>
                </div>
              </div>
              <div className="col-md-12 mt-3">
                <div className="lp-design-div">
                  <div className="cta-main-div">
                    <div className="cta-first-div">
                      <h4 className="cta-heading">
                        Looking for your dream home?
                      </h4>
                      <h4 className="cta-sub-heading">
                        Click for price & availability
                      </h4>
                    </div>
                    <div className="cta-second-div">
                      <button
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop"
                        type="button"
                        onClick={() => handleButtonClick(property.name)}
                        className="cta-button animate__animated animate__pulse animate__infinite"
                      >
                        Check Price{" "}
                        <span className="cta-icon-small">
                          <FaRegClock />
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-12 mt-3">
                <div className="lp-design-div">
                  <h4 className="configuration-txt">Ratings & Reviews</h4>
                  <div className="avg-rating-main-div">
                    <div className="avg-rating-div">
                      <div className="text-center">
                        <h4 className="configuration-txt">4.2</h4>
                        <FaStar className="star-icon" />
                        <FaStar className="star-icon" />
                        <FaStar className="star-icon" />
                        <FaStar className="star-icon" />
                        <FaStarHalfStroke className="star-icon" />
                        <p className="project-overview-txt">Average Rating</p>
                      </div>
                    </div>
                    <div className="star-rating-div"></div>
                  </div>
                </div>
              </div> */}
              {property.name === "Aarav Subhash Residency" ? (
                <>
                  <div className="col-md-12 mt-3">
                    <div className="lp-design-div">
                      <div className="">
                        <h4 className="configuration-txt">
                          Price Trend In {property.name}
                        </h4>
                      </div>
                      <div>
                        <PriceGraph />
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}

              <div className="col-md-12 mt-3">
                <div className="lp-design-div">
                  <div className="">
                    <h4 className="configuration-txt">Amenities & Lifestyle</h4>
                  </div>

                  <div className="amenities">
                    {property.amenities && property.amenities.length > 0 ? (
                      property.amenities.map((amenity, index) => {
                        const IconComponent =
                          amenityIcons[amenity] || FaCheckCircle;
                        return (
                          <div key={index} className="amenity-item">
                            <IconComponent />
                            <p>{amenity}</p>
                          </div>
                        );
                      })
                    ) : (
                      <p>No amenities available</p>
                    )}
                  </div>
                </div>
              </div>
              {/* <div className="col-md-12 mt-3">
                <div className="lp-design-div">
                  <div className="">
                    <h4 className="configuration-txt">Investment Outlook</h4>
                  </div>
                  <div>
                    <p className="project-overview-txt">
                      {`${property.subregion}`} the area has seen a spike in
                      affordable homes in recent times with upgrade like metro
                      developments, railway connectivity, hospitals, movie
                      theaters, and infrastructure updates.Flats in{" "}
                      {`${property.subregion}`} still remains a top choice for
                      both investor and homebuyers looking for affordable
                      housing options that offer both value and lifestyle.
                    </p>
                  </div>
                </div>
              </div> */}
              {property.extraDetails ? (
                <div className="col-md-12 mt-3">
                  <div className="lp-design-div">
                    <div className="">
                      <h4 className="configuration-txt">
                        How is {property.subregion} for property investment?
                      </h4>
                    </div>
                    <div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(property.extraDetails),
                        }}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="col-md-12 mt-3">
                <div className="lp-design-div">
                  <div className="">
                    <h4 className="configuration-txt">
                      About {property.devlopername}
                    </h4>
                  </div>
                  <div>
                    <p className="project-overview-txt">
                      {property.aboutdevloper}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mt-3">
                <div className="lp-design-div">
                  <div className="">
                    <h4 className="configuration-txt">People Also Ask</h4>
                  </div>
                  <div
                    class="accordion custome-accordian"
                    id="accordionExample"
                  >
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          Where is {property.name} located?
                        </button>
                      </h2>
                      <div
                        id="collapseOne"
                        class="accordion-collapse collapse show"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          Located in {property.address}.
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          What is the price range of {property.name}?
                        </button>
                      </h2>
                      <div
                        id="collapseTwo"
                        class="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          Prices range from ₹{property.priceRange}, depending on
                          the unit.
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          Where can I download the {property.name} brochure?
                        </button>
                      </h2>
                      <div
                        id="collapseThree"
                        class="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          You can download the brochure from property portals
                          like <Link to="/">HomesDekho</Link>, MagicBricks, or
                          the official {property.devlopername} website.
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFour"
                          aria-expanded="false"
                          aria-controls="collapseFour"
                        >
                          What is the possession status of {property.name}?
                        </button>
                      </h2>
                      <div
                        id="collapseFour"
                        class="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          The project is currently under construction, and
                          possession is expected in {property.possessiondate}.
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFive"
                          aria-expanded="false"
                          aria-controls="collapseFive"
                        >
                          Is {property.name} RERA approved?
                        </button>
                      </h2>
                      <div
                        id="collapseFive"
                        class="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          Yes, it is RERA-registered under the number{" "}
                          {property.reraName}.
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseSix"
                          aria-expanded="false"
                          aria-controls="collapseSix"
                        >
                          What are the top amenities available in{" "}
                          {property.name}?
                        </button>
                      </h2>
                      <div
                        id="collapseSix"
                        class="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          Amenities include{" "}
                          {property.amenities &&
                          property.amenities.length > 0 ? (
                            property.amenities.join(", ")
                          ) : (
                            <p>No amenities available</p>
                          )}
                          ..
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseSeven"
                          aria-expanded="false"
                          aria-controls="collapseSeven"
                        >
                          Is {property.name} in {property.subregion} a good area
                          to live?
                        </button>
                      </h2>
                      <div
                        id="collapseSeven"
                        class="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          Yes, {property.subregion} is a growing locality with
                          strong connectivity, infrastructure development, and
                          affordable housing options ideal for both end-users
                          and investors.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mt-3">
                <div className="lp-design-div">
                  <div className="">
                    <h4 className="configuration-txt">
                      {property.name} Gallery
                    </h4>
                  </div>
                  <div className="image-gallery">
                    {property &&
                    property.imageUrls &&
                    Array.isArray(property.imageUrls) ? (
                      property.imageUrls.map((_, index) => (
                        <div
                          key={index}
                          className="image-item"
                          data-bs-toggle="modal"
                          data-bs-target="#staticBackdrop"
                          onClick={() => handleButtonClick(property.name)}
                        >
                          <img
                            src={property.imageUrls[index]}
                            alt="Kitchen 2"
                          />
                        </div>
                      ))
                    ) : (
                      <p>Loading data...</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-12 mt-3">
                <div className="lp-design-div">
                  <div className="">
                    <h4 className="configuration-txt">
                      RERA NUMBERS FOR {property.name}
                    </h4>
                  </div>
                  <div className="rera-number-img-div">
                    <img
                      src={property.reraimageURLS}
                      onClick={() => handleButtonClick(property.name)}
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                      className="scanner-img"
                      alt={property.name}
                    />
                    <p className="rera-txt text-center">{property.reraName}</p>
                    <p className="small-rera-txt text-center">
                      Registered With MahaRera
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mt-3">
                <div className="lp-design-div">
                  <div className="">
                    <h4 className="configuration-txt">
                      More Properties Of {property.devlopername}
                    </h4>
                  </div>
                  <DeveloperSlider data={property.devlopername} />
                </div>
              </div>
              <div className="col-md-12 mt-3">
                <div className="lp-design-div">
                  <div className="">
                    <h4 className="configuration-txt">
                      More Properties In{" "}
                      {property.subregion === "Dombivali"
                        ? "Dombivli"
                        : property.subregion}
                    </h4>
                  </div>
                  <SubregionSlider data={property.subregion} />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="side-bar">
          <div className="container">
            <div className="row">
              {/* property detail  */}
              <div className="col-md-12">
                <div className="property-details-div">
                  <ul className="luxury-homes-ul">
                    <li
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                      className="animate__animated animate__pulse animate__infinite"
                      onClick={() => handleButtonClick(property.name)}
                    >
                      Luxury Homes
                    </li>
                  </ul>
                  <div className="side-bar-main-address-div">
                    <div className="side-bar-icon-div">
                      <FaHouse />
                    </div>
                    <div className="side-bar-property-detail-div">
                      <p className="sidebar-property-name-txt">Property Name</p>
                      <p className="sidebar-property-real-name-txt">
                        {property.name}
                      </p>
                    </div>
                  </div>
                  <div className="side-bar-main-address-div mt-2">
                    <div className="side-bar-icon-div">
                      <FaLocationDot />
                    </div>
                    <div className="side-bar-property-detail-div">
                      <p className="sidebar-property-name-txt">Location</p>
                      <p className="sidebar-property-real-name-txt">
                        {property.address}
                      </p>
                    </div>
                  </div>
                  <div className="possesion-date-main-div">
                    <div className="side-bar-main-address-div mt-2">
                      <div className="side-bar-icon-div">
                        <FaKey />
                      </div>
                      <div className="side-bar-property-detail-div">
                        <p className="sidebar-property-name-txt">
                          Possession date
                        </p>
                        <p className="sidebar-property-real-name-txt">
                          {property.possessiondate}
                        </p>
                      </div>
                    </div>
                    <div className="side-bar-main-address-div mt-2">
                      <div className="side-bar-icon-div">
                        <FaIndianRupeeSign />
                      </div>
                      <div className="side-bar-property-detail-div">
                        <p className="sidebar-property-name-txt">Price Range</p>
                        <p className="sidebar-property-real-name-txt">
                          {property.price}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="side-bar-main-address-div mt-2">
                    <div className="side-bar-icon-div">
                      <FaHelmetSafety />
                    </div>
                    <div className="side-bar-property-detail-div">
                      <p className="sidebar-property-name-txt">Developer</p>
                      <p className="sidebar-property-real-name-txt">
                        {property.devlopername}
                      </p>
                    </div>
                  </div>
                  <div className="download-brochure-btn-div">
                    <button
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                      className="download-brochure-btn glow-on-hover animate__animated animate__pulse animate__infinite"
                      type="button"
                      onClick={() => handleButtonClick(property.name)}
                    >
                      Download Brochure
                    </button>
                  </div>
                </div>
              </div>
              {/* property detail  */}
              <div className="col-md-12">
                <div className="main-form-div">
                  <div className="need-help-txt-div">
                    <h4 className="need-help-txt">Need Help?</h4>
                  </div>
                  <div className="lead-form-div">
                    <form onSubmit={handleSubmit} className="lead-form">
                      <input
                        placeholder="Name*"
                        className="lead-form-input"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                      />

                      <input
                        placeholder="Mobile*"
                        className="lead-form-input"
                        type="tel"
                        pattern="[789][0-9]{9}"
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        required
                      />
                      <input
                        placeholder="Email*"
                        className="lead-form-input"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />

                      <div className="download-brochure-btn-div">
                        <button
                          className={`form-enquire-btn ${
                            isSubmitting ? "disabled" : ""
                          }`}
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? "Submitting..." : "Enquire Now"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Success Popup */}
        {showSuccessPopup && (
          <div
            className="modal-overlay"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          >
            <div className="modal-content success-popup">
              <button
                className="close-btn"
                onClick={handleSuccessPopupClose}
                aria-label="Close"
              >
                &times;
              </button>
              <div className="w-100">
                <FaCheckCircle className="success-icon text-center" />
              </div>
              <h2>Thank you!</h2>
              <p>We've received your submission, and we'll be in touch soon!</p>
            </div>
          </div>
        )}
        <Popup data={popupData} />
        <Whatsapp data={property.name} />
      </main>
    </>
  );
};

export default PropertyDetail;
